module.exports = __webpack_public_path__ + "img/status-success.6000ada.svg";